module.exports = __webpack_public_path__ + "img/logo_falabella.cbd6dc19.svg";